import { render, staticRenderFns } from "./PasswordReset.vue?vue&type=template&id=165de6d4&scoped=true&"
import script from "./PasswordReset.vue?vue&type=script&lang=js&"
export * from "./PasswordReset.vue?vue&type=script&lang=js&"
import style0 from "./PasswordReset.vue?vue&type=style&index=0&id=165de6d4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../shared/frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "165de6d4",
  null
  
)

export default component.exports